import { ToolsContainerProps } from '../../../../../../components/Container'
import { nameActions } from '../../info'

export const toolsList: ToolsContainerProps[] = [
  {
    name: nameActions.create.name,
    to: nameActions.create.to,
    icon: nameActions.create.icon,
    hasParams: false,
    color: 'btn-light-success'
  },
  {
    name: 'Adicionar por arquivo',
    to: '/commercial/hirings/import',
    icon: nameActions.create.icon,
    hasParams: false,
    color: 'btn-success'
  }
]
